import { fireStageHelpSwal } from "./stageRules";

/** Per-puzzle how-to-play rules for Escape the Grind */
export const ESCAPE_PUZZLE_RULES = {
  1: {
    triage: {
      title: "Puzzle 1: Eat the Frog (Task Triage)",
      rules: [
        "Review all the tasks displayed on your screen.",
        "Drag each task into one of the four priority buckets: Critical, Important, Planned, or Low Priority.",
        "Use the Triage method to decide which tasks need immediate attention and which can wait.",
        "Once all tasks have been categorized, submit your board to continue.",
      ],
    },
    desk: {
      title: "Puzzle 2: Organize Your Desk",
      rules: [
        "Observe the cluttered workspace carefully.",
        "Drag each office item to its correct location on the desk.",
        "Continue until every object has been placed correctly.",
        "Once the desk is organized, the hidden Meeting Room Access Card will be revealed automatically.",
      ],
    },
    inbox: {
      title: "Puzzle 3: Inbox Triage",
      rules: [
        "You have 260 unread emails, with 10 sample emails displayed for sorting.",
        "Drag each email into the most appropriate category: Action Now, Reply Later, Archive, or Ignore.",
        "Sort all displayed emails to regain control of your inbox and complete the level.",
      ],
    },
  },
  2: {
    calendar: {
      title: "Puzzle 1: Optimize the Calendar",
      rules: [
        "Review the day's meeting schedule.",
        "Reduce unnecessary meeting durations and convert suitable meetings into Walk & Talk sessions.",
        "Add water and stretch breaks between meetings.",
        "Reserve an uninterrupted Focus Block for deep work.",
        "Once the schedule is balanced, submit your calendar to continue.",
      ],
    },
    channel: {
      title: "Puzzle 2: Meeting, Email, or Chat?",
      rules: [
        "Read each workplace scenario carefully.",
        "Decide the most effective communication method: Meeting, Email, or Chat.",
        "Select your answer and review the instant feedback before moving to the next scenario.",
        "Complete all scenarios to unlock the final challenge.",
      ],
    },
    principles: {
      title: "Puzzle 3: Find the Productivity Principles",
      rules: [
        "Explore the meeting room and search for the hidden productivity principle cards.",
        "Collect all five words: PRIORITIZE, PLAN, FOCUS, REST, BALANCE.",
        "Drag the collected words into the correct sequence to complete the productivity framework.",
        "Once all principles are arranged correctly, you'll complete the challenge and escape the grind.",
      ],
    },
  },
};

export function getEscapePuzzleGuide(stageNumber, puzzleKey) {
  return ESCAPE_PUZZLE_RULES[stageNumber]?.[puzzleKey] || null;
}

export function fireEscapeHowToPlay({ stageNumber, puzzleKey, themeData }) {
  const guide = getEscapePuzzleGuide(stageNumber, puzzleKey);
  if (!guide) return;

  fireStageHelpSwal({
    title: guide.title,
    rules: guide.rules,
    themeData,
  });
}
